import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { TranslateModule } from '@ngx-translate/core';

import { ServerErrorPage } from './server-error.page';

@NgModule({
  declarations: [ServerErrorPage],
  imports: [CommonModule, MatButtonModule, TranslateModule],
})
export class ServerErrorPageModule {}
